import { useState } from "react";
import "@/App.css";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, Play, Star, Send, ChevronDown, Image, Loader2 } from "lucide-react";
import { Toaster, toast } from "sonner";

// DONNÉES STATIQUES - Pas besoin de backend
const STATIC_TESTIMONIALS = [
  // ÉCOLE DES MAÎTRES DAUPHINS - VIDEOS
  {
    id: "1",
    name: "Nathalie",
    profession: "Participante École des Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "video",
    video_url: "https://gillesdelieuze.com/wp-content/uploads/2026/01/emd-nathalie.mp4",
    rating: 5
  },
  {
    id: "2",
    name: "Christel",
    profession: "Participante École des Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "video",
    video_url: "https://gillesdelieuze.com/wp-content/uploads/2025/12/2123088E-00DE-4173-B2F6-C391D26F40E7-2.mov",
    rating: 5
  },
  {
    id: "3",
    name: "Aline",
    profession: "Participante École des Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "video",
    video_url: "https://gillesdelieuze.com/wp-content/uploads/2026/01/Temoignage-Aline-3.mp4",
    rating: 5
  },
  {
    id: "4",
    name: "Nelly",
    profession: "Participante École des Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "video",
    video_url: "https://gillesdelieuze.com/wp-content/uploads/2026/01/Temoignage-Nelly.mp4",
    rating: 5
  },
  // ACCORDEUR QUANTIQUE - VIDEOS
  {
    id: "5",
    name: "Marine",
    profession: "Accordeur Quantique labellisé",
    category: "Accordeur Quantique",
    testimonial_type: "video",
    video_url: "https://www.youtube.com/embed/hlu_MZH-nhA",
    rating: 5
  },
  {
    id: "6",
    name: "Lucie",
    profession: "Accordeur Quantique labellisé",
    category: "Accordeur Quantique",
    testimonial_type: "video",
    video_url: "https://www.youtube.com/embed/uHt9d0lFjE0",
    rating: 5
  },
  {
    id: "7",
    name: "Aude",
    profession: "Accordeur Quantique labellisé",
    category: "Accordeur Quantique",
    testimonial_type: "video",
    video_url: "https://www.youtube.com/embed/xAq-FFmIgCE",
    rating: 5
  },
  {
    id: "8",
    name: "Gaëlle Macera",
    profession: "Accordeur Quantique labellisé",
    category: "Accordeur Quantique",
    testimonial_type: "video",
    video_url: "https://www.youtube.com/embed/zJc1ig4RV4Y",
    rating: 5
  },
  {
    id: "9",
    name: "Nathalie Laydet",
    profession: "Accordeur Quantique labellisé",
    category: "Accordeur Quantique",
    testimonial_type: "video",
    video_url: "https://www.youtube.com/embed/_BgWzQoK8tY",
    rating: 5
  },
  {
    id: "10",
    name: "Nathalie P.",
    profession: "Accordeur Quantique labellisé",
    category: "Accordeur Quantique",
    testimonial_type: "video",
    video_url: "https://www.youtube.com/embed/V_obST1pQVo",
    rating: 5
  },
  // ACCORDEUR QUANTIQUE - TEXT
  {
    id: "11",
    name: "Jocelyne Beauvillier",
    profession: "Thérapeute",
    category: "Accordeur Quantique",
    testimonial_type: "text",
    content: "J'ai commencé cette formation presque avec des pincettes, la cymatique, les fréquences, les sons c'était vraiment pas ce que je connaissais dans l'accompagnement. Et dès les premiers lives j'ai été totalement saisie par la puissance des fréquences et son côté très simple. La Formation Accordeur Quantique peut se résumer en un seul mot : Transformation !",
    avatar_url: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face",
    rating: 5
  },
  // ÉCOLE DES MAÎTRES DAUPHINS - SCREENSHOTS
  {
    id: "12",
    name: "Témoignage École Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "screenshot",
    image_url: "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1478-300x221.jpg",
    rating: 5
  },
  {
    id: "13",
    name: "Témoignage École Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "screenshot",
    image_url: "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1479-219x300.jpg",
    rating: 5
  },
  {
    id: "14",
    name: "Témoignage École Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "screenshot",
    image_url: "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1480-300x236.jpg",
    rating: 5
  },
  {
    id: "15",
    name: "Témoignage École Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "screenshot",
    image_url: "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1481-300x283.jpg",
    rating: 5
  },
  {
    id: "16",
    name: "Témoignage École Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "screenshot",
    image_url: "https://gillesdelieuze.com/wp-content/uploads/2024/11/IMG_1482-1024x666.jpg",
    rating: 5
  },
  {
    id: "17",
    name: "Témoignage École Dauphins",
    category: "École des Maîtres Dauphins",
    testimonial_type: "screenshot",
    image_url: "https://gillesdelieuze.com/wp-content/uploads/2024/11/Capture-decran-2024-11-07-a-12.15.22-1024x273.png",
    rating: 5
  },
  // ÉCOLE DES MAÎTRES DAUPHINS - TEXT
  {
    id: "18",
    name: "Sandrine M.",
    profession: "Juriste en reconversion",
    category: "École des Maîtres Dauphins",
    testimonial_type: "text",
    content: "C'est un nouveau départ pour moi, à un moment de ma vie où je devais faire un reset total dans tous les domaines. J'ai trouvé auprès des dauphins et de Gilles le soutien dont j'avais besoin pour poser de nouvelles fondations solides et construire ma nouvelle part de vie avec confiance et fluidité.",
    avatar_url: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face",
    rating: 5
  },
  {
    id: "19",
    name: "Natacha Pradier",
    profession: "Coach en développement personnel",
    category: "École des Maîtres Dauphins",
    testimonial_type: "text",
    content: "J'ai fait beaucoup de formation et souvent je n'allais pas au bout. Pas assez de sens, de profondeur, de pertinence. Après 8 mois je peux affirmer que les changements sont au rdv et que je me métamorphose. Au-delà de techniques, je trouve que tu nous apportes une philosophie de vie profonde, des éclairages précieux, sans jamais prendre le pouvoir...",
    avatar_url: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    rating: 5
  },
  {
    id: "20",
    name: "Luce A.",
    profession: "Retraitée",
    category: "École des Maîtres Dauphins",
    testimonial_type: "text",
    content: "Retraitée depuis 10 ans, j'ai longuement hésité à m'engager. À quoi bon, ma vie est derrière moi... Je n'aime pas l'ordinateur... Toutes les raisons de ne pas faire qui n'ont finalement pas eu raison. Et je me félicite d'avoir contré le mental car je me retrouve. Mon quotidien pétille à nouveau, je ressens beaucoup de paix et de joie.",
    avatar_url: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face",
    rating: 5
  },
  // ACCOMPAGNEMENTS 1:1 - TEXT
  {
    id: "21",
    name: "Ken T.",
    profession: "Entrepreneur",
    category: "Accompagnements 1:1",
    testimonial_type: "text",
    content: "La Vie a pris une nouvelle dimension et je te suis très reconnaissant Gilles. Honnêtement cela a été dur par moment mais ça valait tellement le coup et surtout tu ne m'as jamais lâché la main, dans les moments où j'aurais jeté l'éponge...",
    avatar_url: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    rating: 5
  },
  {
    id: "22",
    name: "Tatiana D.",
    profession: "Coach",
    category: "Accompagnements 1:1",
    testimonial_type: "text",
    content: "La paix que j'ai trouvée épouse désormais ma détermination alignée. Je ne cherche plus à prouver au monde ma valeur, je me révèle et m'offre. Cela paraît rien mais c'est tellement different! Merci.",
    avatar_url: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
    rating: 5
  },
  {
    id: "23",
    name: "Karine G.",
    profession: "Thérapeute",
    category: "Accompagnements 1:1",
    testimonial_type: "text",
    content: "Je ne savais pas bien pourquoi j'avais l'appel de plonger dans cette aventure mais ce fut plus fort que moi. Ce que j'y ai trouvé a éclairé tellement de pans de ma vie et de mon histoire... J'aurais aimé vivre cette initiation avant, même si je sais que c'était pile poil au moment juste.",
    avatar_url: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    rating: 5
  }
];

const categories = [
  "Tous",
  "École des Maîtres Dauphins",
  "Accordeur Quantique",
  "Accompagnements 1:1"
];

// Header Component
const Header = () => (
  <header 
    className="fixed top-0 w-full z-50 bg-[#050814]/70 backdrop-blur-xl border-b border-white/10"
    data-testid="main-nav"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
      <a href="https://gillesdelieuze.com" className="flex items-center gap-3">
        <span className="font-serif text-xl md:text-2xl font-light tracking-tight text-white">
          Gilles <span className="text-[#D4AF37]">Delieuze</span>
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-8">
        <a href="#videos" className="nav-link">Vidéos</a>
        <a href="#temoignages" className="nav-link">Témoignages</a>
        <a href="#partager" className="nav-link">Partager</a>
      </nav>
      <a 
        href="https://gillesdelieuze.com/rdv-clarte-2/" 
        target="_blank" 
        rel="noopener noreferrer"
        className="hidden md:block px-5 py-2 bg-[#D4AF37] text-[#050814] rounded-full text-sm font-medium hover:bg-[#F3E5AB] transition-colors btn-glow"
        data-testid="cta-button"
      >
        RDV Clarté
      </a>
    </div>
  </header>
);

// Hero Section
const HeroSection = () => (
  <section 
    className="relative min-h-[60vh] flex items-center justify-center overflow-hidden hero-bg"
    data-testid="hero-section"
  >
    <div className="hero-overlay absolute inset-0" />
    <div className="relative z-10 text-center px-6 pt-24 pb-16">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-4"
      >
        Ils ont vécu l'expérience
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.1 }}
        className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-white mb-6"
      >
        Témoignages
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-base md:text-lg text-white/60 max-w-2xl mx-auto leading-relaxed"
      >
        Découvrez les transformations profondes vécues par ceux qui ont choisi 
        de plonger dans l'univers des fréquences et de l'accompagnement conscient.
      </motion.p>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="mt-12"
      >
        <ChevronDown className="w-6 h-6 text-[#D4AF37] mx-auto animate-bounce" />
      </motion.div>
    </div>
  </section>
);

// Filter Bar
const FilterBar = ({ activeFilter, setActiveFilter }) => (
  <div 
    className="flex flex-wrap gap-3 md:gap-4 justify-center mb-12 md:mb-16 px-4"
    data-testid="testimonial-filters"
  >
    {categories.map((category) => (
      <button
        key={category}
        onClick={() => setActiveFilter(category)}
        className={`filter-pill ${activeFilter === category ? 'active' : ''}`}
        data-testid={`filter-${category.toLowerCase().replace(/\s+/g, '-')}`}
      >
        {category}
      </button>
    ))}
  </div>
);

// Star Rating Display
const StarRating = ({ rating }) => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${i < rating ? 'star filled' : 'star'}`}
        fill={i < rating ? '#D4AF37' : 'none'}
      />
    ))}
  </div>
);

// Video Testimonial Card - supports both YouTube embeds and MP4 files
const VideoTestimonialCard = ({ testimonial, index }) => {
  const isYouTube = testimonial.video_url?.includes('youtube.com') || testimonial.video_url?.includes('youtu.be');
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="space-y-4"
      data-testid="video-testimonial-card"
    >
      <div className={isYouTube ? "video-card" : "video-card-portrait"}>
        {isYouTube ? (
          <iframe
            src={testimonial.video_url}
            title={`Témoignage de ${testimonial.name}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <video
            controls
            preload="metadata"
            className="w-full h-full object-cover"
          >
            <source src={testimonial.video_url} type="video/mp4" />
            Votre navigateur ne supporte pas la lecture vidéo.
          </video>
        )}
      </div>
      <div className="flex items-center gap-3 px-1">
        <Play className="w-4 h-4 text-[#D4AF37]" />
        <div>
          <p className="font-medium text-white text-sm">{testimonial.name}</p>
          {testimonial.profession && (
            <p className="text-xs text-white/50">{testimonial.profession}</p>
          )}
        </div>
      </div>
    </motion.div>
  );
};

// Screenshot Testimonial Card
const ScreenshotTestimonialCard = ({ testimonial, index }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
    className="group cursor-pointer"
    data-testid="screenshot-testimonial-card"
  >
    <div className="screenshot-card overflow-hidden rounded-xl border border-white/10 transition-all duration-500 hover:border-[#D4AF37]/50 hover:shadow-xl hover:shadow-[#D4AF37]/10">
      <img
        src={testimonial.image_url}
        alt="Témoignage"
        className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
      />
    </div>
  </motion.div>
);

// Text Testimonial Card
const TextTestimonialCard = ({ testimonial, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
    className="testimonial-card group"
    data-testid="text-testimonial-card"
  >
    <div className="relative">
      <Quote className="absolute -top-2 -left-2 w-8 h-8 text-[#D4AF37] opacity-20" />
      <p className="font-serif text-lg italic leading-relaxed text-white/90 pl-6">
        "{testimonial.content}"
      </p>
    </div>
    
    <div className="mt-6 pt-6 border-t border-white/10 flex items-center gap-4">
      {testimonial.avatar_url ? (
        <div className="avatar-ring">
          <img
            src={testimonial.avatar_url}
            alt={testimonial.name}
            className="w-12 h-12 rounded-full object-cover"
          />
        </div>
      ) : (
        <div className="w-12 h-12 rounded-full bg-[#D4AF37]/20 flex items-center justify-center">
          <span className="text-[#D4AF37] font-medium text-lg">
            {testimonial.name.charAt(0)}
          </span>
        </div>
      )}
      <div>
        <p className="font-medium text-white">{testimonial.name}</p>
        {testimonial.profession && (
          <p className="text-sm text-white/50">{testimonial.profession}</p>
        )}
      </div>
      <div className="ml-auto">
        <StarRating rating={testimonial.rating} />
      </div>
    </div>
  </motion.div>
);

// Submission Form - envoie par email via mailto
const SubmissionForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    profession: '',
    email: '',
    category: '',
    content: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name?.trim()) {
      toast.error("Veuillez entrer votre nom");
      return;
    }
    if (!formData.email?.trim()) {
      toast.error("Veuillez entrer votre email");
      return;
    }
    if (!formData.category) {
      toast.error("Veuillez choisir un programme");
      return;
    }
    if (!formData.content?.trim()) {
      toast.error("Veuillez écrire votre témoignage");
      return;
    }

    setIsSubmitting(true);
    
    // Créer le lien mailto
    const subject = encodeURIComponent(`Nouveau témoignage de ${formData.name} - ${formData.category}`);
    const body = encodeURIComponent(`
Nouveau témoignage reçu :

Nom : ${formData.name}
Profession : ${formData.profession || 'Non spécifiée'}
Email : ${formData.email}
Programme : ${formData.category}

Témoignage :
"${formData.content}"
    `);
    
    window.location.href = `mailto:gilles@centre-terre-ciel.com?subject=${subject}&body=${body}`;
    
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success("Votre client mail va s'ouvrir pour envoyer le témoignage");
      setFormData({
        name: '',
        profession: '',
        email: '',
        category: '',
        content: ''
      });
    }, 1000);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-8" data-testid="submission-form">
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Votre nom *"
            className="form-input"
            data-testid="form-name"
          />
        </div>
        <div>
          <input
            type="text"
            name="profession"
            value={formData.profession}
            onChange={handleChange}
            placeholder="Votre profession (optionnel)"
            className="form-input"
            data-testid="form-profession"
          />
        </div>
      </div>
      
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Votre email *"
            className="form-input"
            data-testid="form-email"
          />
        </div>
        <div>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="form-select"
            data-testid="form-category"
          >
            <option value="">Choisir un programme *</option>
            <option value="École des Maîtres Dauphins">École des Maîtres Dauphins</option>
            <option value="Accordeur Quantique">Accordeur Quantique</option>
            <option value="Accompagnements 1:1">Accompagnements 1:1</option>
          </select>
        </div>
      </div>
      
      <div>
        <textarea
          name="content"
          value={formData.content}
          onChange={handleChange}
          placeholder="Partagez votre expérience... *"
          className="form-input form-textarea"
          data-testid="form-content"
        />
      </div>
      
      <button
        type="submit"
        disabled={isSubmitting}
        className="submit-btn flex items-center justify-center gap-2"
        data-testid="form-submit"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            Envoi en cours...
          </>
        ) : (
          <>
            <Send className="w-5 h-5" />
            Envoyer mon témoignage
          </>
        )}
      </button>
      
      <p className="text-center text-white/40 text-sm">
        Votre témoignage sera envoyé à Gilles pour validation avant publication.
      </p>
    </form>
  );
};

// Footer
const Footer = () => (
  <footer className="bg-[#0B1121] border-t border-white/10 py-16">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <span className="font-serif text-2xl font-light text-white">
            Gilles <span className="text-[#D4AF37]">Delieuze</span>
          </span>
          <p className="mt-4 text-sm text-white/50 leading-relaxed">
            Coach transformationnel, formateur en leadership conscient, 
            et guide de réinitialisation profonde.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-white mb-4 uppercase tracking-wider">Programmes</h4>
          <ul className="space-y-3">
            <li>
              <a href="https://gillesdelieuze.com/lecole-des-maitres-dauphins/" className="footer-link" target="_blank" rel="noopener noreferrer">
                École des Maîtres Dauphins
              </a>
            </li>
            <li>
              <a href="https://gillesdelieuze.com/accordeur-quantique-2024/" className="footer-link" target="_blank" rel="noopener noreferrer">
                Accordeur Quantique
              </a>
            </li>
            <li>
              <a href="https://gillesdelieuze.com/accompagnements-11/" className="footer-link" target="_blank" rel="noopener noreferrer">
                Accompagnements 1:1
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-medium text-white mb-4 uppercase tracking-wider">Contact</h4>
          <p className="text-sm text-white/50">
            Espace Asanoha<br />
            7 Rue de l'Église<br />
            11200 Ornaisons
          </p>
          <p className="mt-4 text-sm text-white/50">
            <a href="mailto:gilles@centre-terre-ciel.com" className="hover:text-[#D4AF37] transition-colors">
              gilles@centre-terre-ciel.com
            </a>
          </p>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-white/10 text-center">
        <p className="text-sm text-white/40">
          © {new Date().getFullYear()} Gilles Delieuze. Tous droits réservés.
        </p>
      </div>
    </div>
  </footer>
);

// Main App Component
function App() {
  const [activeFilter, setActiveFilter] = useState("Tous");

  // Filtrer les témoignages selon la catégorie sélectionnée
  const filteredTestimonials = activeFilter === "Tous" 
    ? STATIC_TESTIMONIALS 
    : STATIC_TESTIMONIALS.filter(t => t.category === activeFilter);

  const videoTestimonials = filteredTestimonials.filter(t => t.testimonial_type === 'video');
  const screenshotTestimonials = filteredTestimonials.filter(t => t.testimonial_type === 'screenshot');
  const textTestimonials = filteredTestimonials.filter(t => t.testimonial_type === 'text');

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header />
      <HeroSection />

      {/* Filter Bar - Global */}
      <section className="py-12 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <FilterBar activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
        </div>
      </section>

      {/* Video Testimonials Section - FIRST */}
      {videoTestimonials.length > 0 && (
        <section id="videos" className="py-12 md:py-20 px-6 md:px-12 lg:px-24 bg-[#0B1121]/50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <p className="uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-3">
                Vidéos
              </p>
              <h2 className="font-serif text-3xl md:text-4xl font-light tracking-tight text-white">
                Découvrez leurs transformations
              </h2>
              <div className="section-divider mx-auto mt-4" />
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={activeFilter + '-videos'}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8"
              >
                {videoTestimonials.map((testimonial, index) => (
                  <VideoTestimonialCard
                    key={testimonial.id}
                    testimonial={testimonial}
                    index={index}
                  />
                ))}
              </motion.div>
            </AnimatePresence>
          </div>
        </section>
      )}

      {/* Screenshot Testimonials Section */}
      {screenshotTestimonials.length > 0 && (
        <section className="py-12 md:py-20 px-6 md:px-12 lg:px-24">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <p className="uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-3">
                <Image className="w-4 h-4 inline mr-2" />
                Captures
              </p>
              <h2 className="font-serif text-3xl md:text-4xl font-light tracking-tight text-white">
                Messages reçus
              </h2>
              <div className="section-divider mx-auto mt-4" />
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={activeFilter + '-screenshots'}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
              >
                {screenshotTestimonials.map((testimonial, index) => (
                  <ScreenshotTestimonialCard
                    key={testimonial.id}
                    testimonial={testimonial}
                    index={index}
                  />
                ))}
              </motion.div>
            </AnimatePresence>
          </div>
        </section>
      )}

      {/* Text Testimonials Section */}
      <section id="temoignages" className="py-12 md:py-20 px-6 md:px-12 lg:px-24 bg-[#0B1121]/30">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <p className="uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-3">
              Transformations
            </p>
            <h2 className="font-serif text-3xl md:text-4xl font-light tracking-tight text-white">
              Leurs mots, leurs parcours
            </h2>
            <div className="section-divider mx-auto mt-4" />
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeFilter}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
            >
              {textTestimonials.map((testimonial, index) => (
                <TextTestimonialCard
                  key={testimonial.id}
                  testimonial={testimonial}
                  index={index}
                />
              ))}
            </motion.div>
          </AnimatePresence>

          {textTestimonials.length === 0 && (
            <p className="text-center text-white/50 py-12">
              Aucun témoignage écrit dans cette catégorie pour le moment.
            </p>
          )}
        </div>
      </section>

      {/* Submission Form Section */}
      <section id="partager" className="py-20 md:py-28 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <p className="uppercase text-xs tracking-[0.2em] text-[#D4AF37] mb-3">
              Votre expérience
            </p>
            <h2 className="font-serif text-3xl md:text-4xl font-light tracking-tight text-white">
              Partagez votre témoignage
            </h2>
            <div className="section-divider mx-auto mt-4" />
            <p className="mt-6 text-white/60 leading-relaxed">
              Votre histoire peut inspirer d'autres âmes en quête de transformation.
              Partagez votre parcours avec nous.
            </p>
          </div>

          <div className="form-container">
            <SubmissionForm />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default App;
